var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.seconds)?_c('div',{ref:"time",staticClass:"timer icon-hourglass"},[_c('div',{staticClass:"timer__time",class:( _obj = {}, _obj[("timer__time--" + _vm.theme)] = _vm.theme, _obj )},[_vm._v(" "+_vm._s(_vm.time)+" ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }